module.exports = __webpack_public_path__ + "media/images/point/commodity_figure-f50a3ea34d430933cd775c92441b3ea8.jpg";